__turbopack_context__.v({
  "mobileButton": "ComponentHeader-module-scss-module__y3TwYa__mobileButton",
});
